import React from 'react';
import { useEffect, useRef, useState } from 'react'
import {
  SActionBtn,
  SBack,
  SLowcodeList,
  STableActions,
  SMessage,
} from 'shj-components'
import { getPackTreeNode } from '@/services/product'
import lodash from 'lodash'
import EditSpecConfigModal from '../components/editSpecConfigModal';
import { message } from 'antd';

export default function SpaceSpecsStep2 ({
  packId = '',
  listRef = {},
  specsArgList = [],
  spaceList = [],
  specsArgMap = {},
  preTableData = [],
  tableData = [],
  setTableData = (a) => ({})
})  {
  const [openConfigModal, setOpenConfigModal] = useState(false)
  const [openDictionaryModal, setOpenDictionaryModal] = useState(false)
  const [editId, setEditId] = useState('');
  const [originSkuList, setOriginSkuList] = useState([])
  const [editData, setEditData] = useState({});

  useEffect(() => {
    if (Array.isArray(preTableData)) {
      formatTableData(preTableData);
    }
  }, [preTableData, originSkuList])

  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = async () => {
    try {
      const res: any = await getPackTreeNode({
        sourceType: 'PACK_MODEL',
        sourceId: packId,
        hasSpaceTag: true,
        expirationTimeIsNull: true,
        busTypes: ['PRD_PRODUCT','PRD_GEN_ITEM']
      });
      if (res?.length) {
        setOriginSkuList(res);
      }
    } catch (err) {
      console.log(err)
    }
  }

  const formatTableData = (preTableData: any) => {
    // 记录第一步空间code和规格参数的映射关系
    const spaceToSpecMap = {};
    preTableData?.forEach((data: any) => {
      spaceToSpecMap[data?.spaceCode] = data?.spaceSpecParamId;
    });
    // 记录第二步旧数据空间code和规格参数的映射关系
    const oldSpaceToSpecMap = {};
    tableData?.forEach((data: any) => {
      oldSpaceToSpecMap[data?.spaceTag] = data?.spaceSpecParamId;
    });
    // 对比第一步和第二步map数据来进行数据处理
    let cloneData: any = lodash.cloneDeep(tableData);
    const oldSpaceCodeList = Object.keys(oldSpaceToSpecMap);
    const newSpaceCodeList = Object.keys(spaceToSpecMap);
    // 先判断第一步有没有删除空间，有删除，第二步要先把对应空间数据删除
    const filterOldList = oldSpaceCodeList?.filter((code: string) => !newSpaceCodeList.includes(code));
    if (filterOldList?.length) {
      filterOldList?.forEach((code: string) => {
        cloneData = cloneData?.filter((item: any) => item?.spaceTag !== code);
      })
    }
    // 在判断有没有需要从原数据新增，或者空间改了规格参数名需要先删除再新增的情况
    newSpaceCodeList?.forEach((spaceCode: string) => {
      // 没包含 需要新增的情况
      if (!oldSpaceCodeList.includes(spaceCode)) {
        const newList = originSkuList?.filter((item: any) => item.spaceTag === spaceCode);
        const formatNewList = newList.map((item: any) => {
          const spaceName = spaceList?.filter((space: any) => space.code === item.spaceTag)?.[0]?.name;
          const spaceSpecParamItem = specsArgList?.filter((spec: any) => spec.id === spaceToSpecMap[spaceCode])?.[0];
          return {
            ...item,
            spaceName,
            spaceSpecParamId: spaceSpecParamItem?.id,
            spaceSpecParamName: spaceSpecParamItem?.argName,
            spaceSpecParamValueIds: ['0'], // 默认是通用
            spaceSpecParamValues: [{ id: '0', argValue: '通用' }]
          }
        })
        cloneData = [...cloneData, ...formatNewList];
        return;
      }
      // 包含了，但是规格参数值不等，需要删除再新增
      if (spaceToSpecMap[spaceCode] !== oldSpaceToSpecMap[spaceCode]) {
        cloneData = cloneData?.filter((item: any) => item.spaceTag !== spaceCode);
        const newList = originSkuList?.filter((item: any) => item.spaceTag === spaceCode);
        const formatNewList = newList?.map((item: any) => {
          const spaceName = spaceList?.filter((space: any) => space.code === item.spaceTag)?.[0]?.name;
          const spaceSpecParamItem = specsArgList?.filter((spec: any) => spec.id === spaceToSpecMap[spaceCode])?.[0];
          return {
            ...item,
            spaceName,
            spaceSpecParamId: spaceSpecParamItem?.id,
            spaceSpecParamName: spaceSpecParamItem?.argName,
            spaceSpecParamValueIds: ['0'], // 默认是通用
            spaceSpecParamValues: [{ id: '0', argValue: '通用' }]
          }
        })
        cloneData = [...cloneData, ...formatNewList];
      }
    })
    console.log('--------', cloneData)
    setTableData(cloneData);
    listRef.current?.updateDataSource(cloneData, cloneData?.length);
  }

  const config = {
    rowSelection: true,
    columns: [
      {
        title: '空间标签',
        key: 'spaceName',
        dataIndex: 'spaceName',
        width: 200,
        ellipsis: {
          showTitle: true,
        }
      },
      {
        title: '通项名称/产品SKU名称',
        key: 'nodeName',
        dataIndex: 'nodeName',
        width: 200,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: '规格参数名称',
        key: 'spaceSpecParamName',
        dataIndex: 'spaceSpecParamName',
        width: 200,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: '规格参数值',
        key: 'spaceSpecParamValues',
        dataIndex: 'spaceSpecParamValues',
        width: 200,
        ellipsis: {
          showTitle: true,
        },
        render: (records) => {
          return (<span> { records?.map(item => item.argValue).join('，') || '' } </span>)
        }
      },
      {
        title: '操作',
        dataIndex: 'actions',
        width: 120,
        render: 'actionRender',
        fixed: 'right',
      },
    ],
    search: [
      {
        label: '空间标签',
        name: 'space',
        itemType: 'select',
        data: spaceList,
        labelKey: 'name',
        key: 'code',
      },
    ],
    footer: [
      {
        label: '配置参数值',
        // auth: 'priceButton1',
        type: 'primary',
        events: ['onClick:onAdd'],
      },
    ],
  }

  const fetchList = async values => {
    let tableList = lodash.cloneDeep(tableData);
    if (values?.query?.space) {
      tableList = tableList.filter((data: any) => data.spaceTag === values?.query?.space);
    }
    return { total: tableList.length, records: tableList }
  }

  const onAdd = () => {
    setEditId('');
    const spaceList: any = [];
    const [_, rows] = listRef?.current?.getSelectedRows();
    rows.forEach((row: any) => {
      if (spaceList.includes(row.spaceTag)) {
        return;
      }
      spaceList.push(row.spaceTag);
    })
    if (!spaceList.length) {
      message.info('请先勾选数据！');
      return;
    }
    if (spaceList.length > 1) {
      message.info('请选择空间相同的数据！');
      return;
    }
    setEditData({
      spaceSpecParamValues: rows?.[0]?.spaceSpecParamValues,
      spaceSpecParamId: rows?.[0]?.spaceSpecParamId,
      spaceSpecParamName: rows?.[0]?.spaceSpecParamName,
    })
    setOpenConfigModal(true);
  }

  const onEdit = (record: any = {}) => {
    setEditId(record?.id);
    setEditData({
      spaceSpecParamValues: record.spaceSpecParamValues,
      spaceSpecParamId: record.spaceSpecParamId,
      spaceSpecParamName: record.spaceSpecParamName,
    })
    setOpenConfigModal(true);
  }

  const addConfirmSpacesSpecs = (value: any) => {
    const [ids] = listRef?.current?.getSelectedRows();
    const hasGeneral = value?.includeValueIds?.includes('0');
    if (hasGeneral && value?.includeValueIds?.length > 1) {
      message.error('适用门店包含通用和其它具体门店互斥');
      return;
    }
    const specsIds = hasGeneral ? ['0'] : value?.includeValueIds;
    const includeValues = hasGeneral ? [{ id: '0', argValue: '通用' }] : specsArgMap?.[editData?.spaceSpecParamId]?.filter((item: any) => value?.includeValueIds?.includes(item.id));
    const newData = tableData?.map((data: any) => {
      if (ids.includes(data?.id)) {
        return {
          ...data,
          spaceSpecParamValueIds: specsIds,
          spaceSpecParamValues: includeValues
        }
      } else {
        return {
          ...data,
        }
      }
    });
    setTableData(newData);
    const searchValue = listRef.current?.getSearch()?.getFieldValue('space')
    const filterList = searchValue ? newData.filter((item: any) => item.spaceTag === searchValue) : newData;
    listRef.current?.updateDataSource(filterList, filterList?.length);
    setOpenConfigModal(false);
  }

  const confirmSpaceSpecs = (value: any) => {
    const hasGeneral = value?.includeValueIds?.includes('0');
    if (hasGeneral && value?.includeValueIds?.length > 1) {
      message.error('适用门店包含通用和其它具体门店互斥');
      return;
    }
    const specsIds = hasGeneral ? ['0'] : value?.includeValueIds;
    const includeValues = hasGeneral ? [{ id: '0', argValue: '通用' }] : specsArgMap?.[editData?.spaceSpecParamId]?.filter((item: any) => value?.includeValueIds?.includes(item.id));
    const newData = tableData?.map((data: any) => {
      if (data?.id === editId) {
        return {
          ...data,
          spaceSpecParamValueIds: specsIds,
          spaceSpecParamValues: includeValues
        }
      } else {
        return {
          ...data,
        }
      }
    });
    setTableData(newData);
    const searchValue = listRef.current?.getSearch()?.getFieldValue('space')
    const filterList = searchValue ? newData.filter((item: any) => item.spaceTag === searchValue) : newData;
    listRef.current?.updateDataSource(filterList, filterList?.length);
    setOpenConfigModal(false);
  }

  // 表格配置
  const extensions = {
    request: { fetchList },
    events: { onAdd, onEdit },
    status: {
      // selectedDisabled: ({ selectedRowKeys }: any) => !selectedRowKeys.length,
      // radioDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length !== 1,
      // exportLoading: state.exportLoading,
    },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>
              编辑
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return (
    <div>
      {/* 右侧数据表格 */}
      <div>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      </div>
      {
        openConfigModal &&
          <EditSpecConfigModal
            editId={editId}
            editData={editData}
            openModal={openConfigModal}
            setOpenModal={setOpenConfigModal}
            specsArgMap={specsArgMap}
            confirm={confirmSpaceSpecs}
            addConfirm={addConfirmSpacesSpecs}
          />
      }
    </div>
  )
}